import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=7cc6e3ae&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=ts&"
export * from "./edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc6e3ae",
  null
  
)

export default component.exports